<template>
  <div>
    <Header class="relative z-20 sm:z-1"></Header>
    <DetailsPanel v-on:localizeSensor="centerMap($event)"/>
    <div class="map relative">
      <Googlemap
        ref="map"
        :centerLatitude="center.lat"
        :centerLongitude="center.lon"
        :markers="sensors"
        @boundsChanged="updateSensors"
      />
      <MapLegend/>
    </div>
  </div>
</template>
 
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Googlemap from '@/components/organisms/Map';
import DetailsPanel from '@/components/organisms/DetailsPanel';
import Header from '@/components/molecules/Header';
import MapLegend from '@/components/atoms/MapLegend';

export default {
  components: {
    Googlemap,
    DetailsPanel,
    Header,
    MapLegend,
  },

  data() {
    return {
      refreshInterval: null,
      center: {
        // poland geo-center
        lat: 52.1979365,
        lon: 19.353756,
      },
    };
  },

  watch: {
    '$route.params'(params) {
      this.updateSensor(params.id);
    },

    'sensor.geolocation'(position) {
      if (position && position.lat !== this.center.lat && position.lon !== this.center.lon) {
        this.centerMap(position);
        this.center = position;
      }
    },
  },

  created() {
    if (this.$route) {
      this.updateSensor(this.$route.params.id);
    }
  },

  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },

  computed: {
    ...mapGetters([
      'sensors',
      'sensor',
    ]),
  },

  methods: {
    ...mapActions([
      'getSensors',
      'getSensor',
    ]),

    ...mapMutations([
      'setSensor',
    ]),

    centerMap(position) {
      this.$refs.map.centerMap(position);
    },

    updateSensor(sensorId) {
      if (sensorId) {
        this.getSensor(sensorId);
      } else {
        this.setSensor(null);
      }
    },

    updateSensors() {
      this.getSensors();
      clearInterval(this.refreshInterval);
      // refresh sensors list every hour
      this.refreshInterval = setInterval(this.getSensors, 1000 * 60 * 30);
    },
  },
};
</script>

<style lang="scss">
.sensor-details + .map {
  @media (min-width: theme('screens.sm')) {
    @apply .ml-80;
    transition: margin 0s;
    transition-delay: .3s;
  }

  @media (min-width: theme('screens.lg')) {
    @apply .ml-96;
  }
}
</style>
